import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-2 flex min-h-screen items-center justify-center bg-gray-100" }
const _hoisted_2 = { class: "w-full max-w-md p-8 bg-white dark:border-gray-800 shadow-md rounded-md" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-red-500 text-sm mb-4"
}

import { ref } from 'vue';
  import { useAuth } from '@/store/auth';
  import { useRouter } from 'vue-router';
  import analyticsCar from '@/helpers/analytics-car';
  import ButtonCustom from '@/components/components/buttonCustom.vue';
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

  const email = ref('');
  const password = ref('');
  const error = ref('');
  const isLoading = ref<boolean>(false);
  const { login } = useAuth();
  const route = useRouter();
  const handleLogin = async () => {
    isLoading.value = true;
    if (!email.value || !password.value) {
      error.value = 'Please fill in all fields.';
      isLoading.value = false;
      return;
    }

    try {
      await login(email.value, password.value);
      await analyticsCar.token();
      await route.push({
        name: 'calculator',
      });
      window.location.reload();
    } catch (e) {
      isLoading.value = false;
      error.value = 'Invalid credentials. Please try again.';
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-2xl font-bold text-center text-gray-800 mb-6" }, "Login", -1)),
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleLogin, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("label", {
            for: "email",
            class: "block text-gray-700 font-medium mb-2"
          }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            type: "email",
            id: "email",
            class: "w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-200",
            placeholder: "Enter your email"
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            for: "password",
            class: "block text-gray-700 font-medium mb-2"
          }, "Password", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            type: "password",
            id: "password",
            class: "w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-200",
            placeholder: "Enter your password"
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        _createVNode(ButtonCustom, {
          title: "Login",
          loading: isLoading.value
        }, null, 8, ["loading"])
      ], 32)
    ])
  ]))
}
}

})